import { FC, ReactNode } from "react";
import { BoxProps } from "@otrium/core";
import { EmotionBaseProps as BaseProps } from "src/types/global";
import { RightAdornment, Wrapper } from "./MobileFilterLabel.styled";

interface Props {
  leftAdornment?: ReactNode;
  rightAdornment?: ReactNode;
  onClick?: () => void;
  labelComponent: ReactNode;
  borderColor?: string;
}

const MobileFilterLabel: FC<BoxProps & BaseProps & Props> = ({
  leftAdornment,
  rightAdornment,
  onClick,
  labelComponent,
  ...rest
}) => (
  <Wrapper onClick={onClick} as="a" {...rest}>
    {leftAdornment && leftAdornment}
    {labelComponent}
    {rightAdornment && <RightAdornment>{rightAdornment}</RightAdornment>}
  </Wrapper>
);

export default MobileFilterLabel;
